import PropTypes from 'prop-types';
import styled from 'styled-components';

import SolarIcon from '../../assets/svg/icon/solar.svg';

const IconWrapper = styled.div`
  position: absolute;
  top: ${({ top }) => top}px;
  width: 100%;
  z-index: 100;
`;
const IconDisc = styled.div`
  background: ${(props) => props.theme.colors.gradients.solarReverse};
  border-radius: 50%;
  border: 3px solid ${(props) => props.theme.colors.white};
  padding: 15px;
  margin-left: auto;
  margin-right: auto;
  width: 85px;
`;

const SolarIconDisc = ({ top }) => (
  <div className="position-relative">
    <IconWrapper top={top}>
      <IconDisc>
        <img alt="Solar icon" src={SolarIcon} />
      </IconDisc>
    </IconWrapper>
  </div>
);

SolarIconDisc.propTypes = {
  top: PropTypes.number,
};

SolarIconDisc.defaultProps = {
  top: 0,
};

export default SolarIconDisc;
